import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { findDOMNode } from 'react-dom';
import { safeInvoke } from '../../../library';
export var ResizeSensor = function (_React$PureComponent) {
  _inherits(ResizeSensor, _React$PureComponent);
  var _super = _createSuper(ResizeSensor);
  function ResizeSensor() {
    var _this;
    _classCallCheck(this, ResizeSensor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "element", null);
    _defineProperty(_assertThisInitialized(_this), "observer", new ResizeObserver(function (entries) {
      return safeInvoke(_this.props.onResize, entries);
    }));
    _defineProperty(_assertThisInitialized(_this), "observeElement", function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var element = _this.getElement();
      if (!(element instanceof Element)) {
        _this.observer.disconnect();
        return;
      }
      if (element === _this.element && !force) {
        return;
      } else {
        _this.observer.disconnect();
        _this.element = element;
      }
      _this.observer.observe(element);
      if (_this.props.observeParents) {
        var parent = element.parentElement;
        while (parent != null) {
          _this.observer.observe(parent);
          parent = parent.parentElement;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getElement", function () {
      try {
        return findDOMNode(_assertThisInitialized(_this));
      } catch (_unused) {
        return null;
      }
    });
    return _this;
  }
  _createClass(ResizeSensor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.observeElement();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.observeElement(this.props.observeParents !== prevProps.observeParents);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observer.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return ResizeSensor;
}(React.PureComponent);